<template>

<com-item name="game.peers.ratings" :size="size" :is-blank="true" :loading="loading" :is-empty="!active" title="Ratings">

	<template v-slot:about>

		<p>How geekGroup users rate this game on the 1-10 scale.</p>

	</template>

	<template v-slot:stats>

		<app-visualisation-accordian :data="accordian" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	data: function() {

		return {
			accordian: {
				noun: 'rater',
				tooltip: '{{value}} {{noun}}',
				values: [],
				labels: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
				images: [],
				colors: [
					'#db303b',
					'#db303b',
					'#df4751',
					'#df4751',
					'#5369a2',
					'#5369a2',
					'#1d8acd',
					'#2FC482',
					'#249563',
					'#249563'
				]
			}
		}

	},

	computed: {

		loading: function() { return this.fetching === 'all' },

		data: function() { return this.$store.getters['page/insights/game/peers'] },

		active: function() { return this.data && !this.loading && this.data.ratingDistribution }

	},

	created: function() { this.visualise() },

	watch: { data: function() { this.visualise() } },

	methods: {

		visualise: function() {

			if (!this.data || !this.data.ratingDistribution) return

			var dist = this.data.ratingDistribution

			this.accordian.values = []
			this.accordian.images = []

			for (var i = 1; i <= 10; i++) {

				this.accordian.values.push(dist[i] || 0)
				this.accordian.images.push(0)

			}

		}

	}

}

</script>

<style scoped>

>>> .accordian-segment {
	cursor: default;
}

</style>
